// extracted by mini-css-extract-plugin
module.exports = {"detailLevel":"Activities_detailLevel__mVcvj","activities":"Activities_activities__YymTb"};